import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})

export class LocalStorageService {
    constructor() { }

    get accessToken(): string {
        return localStorage.getItem('accessToken');
    }

    set accessToken(value: string) {
        localStorage.setItem('accessToken', `Bearer ${value}`);
    }

    get refreshToken(): string {
        return localStorage.getItem('refreshToken');
    }

    set refreshToken(value: string) {
        localStorage.setItem('refreshToken', value)
    }

    get loggedInUser() {
        return !!localStorage.getItem("accessToken");
    }

    logoutUser() {
        // localStorage.clear();
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    }

    set logToken(value: string) {
        localStorage.setItem('_lt', `${value}`)
    }

    get logToken(): string {
        return localStorage.getItem('_lt');
    }

    set browserID(value: string) {
        localStorage.setItem('_bid', `${value}`)
    }

    get browserID(): string {
        return localStorage.getItem('_bid');
    }

    set invitationCode(value: string) {
        if(value) {
            localStorage.setItem('_ic', value);
        } else {
            localStorage.removeItem('_ic');
        }
    }

    get invitationCode(): string {
        return localStorage.getItem('_ic');
    }

    getData(key: string) {
        return localStorage.getItem(key);
    } 

    setData(key: string, value: string) {
        return localStorage.setItem(key, value);
    }

}
